import { useState, useEffect } from "react";
import editar from '../../assets/img/botao-editar-black.svg';
import excluir from '../../assets/img/remover.svg';
import api from "../../api";
import Swal from "sweetalert2";
import '../componentsCss/ProfessionalsModal.css';
import useProfessionalsData from './hooks/useProfessionalsData.js';
import { useParams } from "react-router-dom";

const ProceduresModal = ({ isOpen, onClose, items }) => {
    const { id } = useParams();
    const { professionalsData, loadingProfessionals, errorProfessionals } = useProfessionalsData('/api/affiliatecompany/list/shopper/procedures/all', id, 14);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedItems, setSelectedItems] = useState([]); // Estado final após confirmação
    const [adicionar, setAdicionar] = useState([]); // Itens a adicionar
    const [remover, setRemover] = useState([]); // Itens a remover
    const [professionalsDataAux, setProfessionalsDataAux] = useState([]);
    const professionals = professionalsDataAux || [];

    useEffect(() => {
        if (professionalsData?.procedures) {
            setProfessionalsDataAux(
                [...professionalsData.procedures].sort((a, b) => a.name.localeCompare(b.name))
            );
        }
    }, [professionalsData]);

    const handleClose = () => {
        if (adicionar.length != 0 || remover.length != 0) {
            Swal.fire({
                title: 'Profissionais não alterados',
                icon: 'info',
                confirmButtonColor: '#3c8dbc',
                confirmButtonText: 'Ok',
                cancelButtonText: 'Cancelar',
                showCancelButton: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    onClose();
                    setAdicionar([]);
                    setRemover([]);
                }
                else if (result.isDenied) {
                    return;
                }
            });
        }else{
            onClose();
            setAdicionar([]);
            setRemover([]);
        }
    };
    
    
    useEffect(() => {   
        const initialSelection = items.filter(item => item.falg_exist);
        setSelectedItems(initialSelection);
    }, [items]);

    
    useEffect(() => {
        console.log("Selecionados (Confirmados):", selectedItems);
        console.log("Para Adicionar:", adicionar);
        console.log("Para Remover:", remover);
    }, [selectedItems, adicionar, remover]);


    const confirmarProcedimentos = async (procedures) => {
        const hasInvalidPrices = procedures.some((proc) => proc.cost_price <= 0 || proc.selling_price <= 0);
    
        if (hasInvalidPrices) {
            alert("Por favor, insira preços válidos para todos os procedimentos.");
            return;
        }
    
        try {
            const response = await api.post(
                "/api/affiliatecompany/add/shopper/procedures/relationship",
                {
                    id: id,
                    shopper_id: 14,
                    procedures
                }
            );
    
            Swal.fire({
                title: "Procedimentos salvos com sucesso!",
                icon: "success",
            }).then(() => {
                onClose(); // Fecha o modal após salvar
            });
    
            console.log(response.data);
        } catch (error) {
            console.error("Erro ao salvar procedimentos:", error);
            alert("Erro ao salvar. Verifique os dados e tente novamente.");
        }
    };
    

    const handleToggleItem = (item) => {
        const isBeingAdded = adicionar.some(i => i.id === item.id);
        const isBeingRemoved = remover.some(i => i.id === item.id);
        const isCurrentlySelected = selectedItems.some(i => i.id === item.id) || item.falg_exist;
    
        if (isBeingAdded) {
            // Se o item está na lista de adição, removemos ele da adição
            setAdicionar(prev => prev.filter(i => i.id !== item.id));
        } else if (isBeingRemoved) {
            // Se o item está na lista de remoção, removemos da remoção e recolocamos na seleção
            setRemover(prev => prev.filter(i => i.id !== item.id));
            setSelectedItems(prev => [...prev, item]);
        } else if (isCurrentlySelected) {
            // Se o item está atualmente selecionado, devemos removê-lo
            setRemover(prev => [...prev, item]);
            setSelectedItems(prev => prev.filter(i => i.id !== item.id));
        } else {
            // Se o item não estava selecionado nem marcado para remover, adicionamos ele
            setAdicionar(prev => [...prev, item]);
        }
    };
    const handleConfirmSelection = async () => {
        Swal.fire({
            title: 'Confirmação',
            text: 'Deseja confirmar a seleção?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                if (adicionar.length === 0 && remover.length === 0) {
                    Swal.fire("Nenhuma alteração feita!", "Nenhum procedimento foi adicionado ou removido.", "info");
                    return;
                }
                
                try {
                    // Mapeia os procedimentos a serem adicionados/removidos
                    const formattedProcedures = [
                        ...adicionar.map(item => ({
                            id: item.id,
                            cost_price: parseFloat(item.cost_price || 0).toFixed(2),
                            selling_price: parseFloat(item.selling_price || 0).toFixed(2),
                            flag_delete: false
                        })),
                        ...remover.map(item => ({
                            id: item.id,
                            cost_price: parseFloat(item.cost_price || 0).toFixed(2),
                            selling_price: parseFloat(item.selling_price || 0).toFixed(2),
                            flag_delete: true
                        }))
                    ];
    
                    // Chama a API para salvar os procedimentos
                    await confirmarProcedimentos(formattedProcedures);
    
                    // Atualiza os estados locais
                    setSelectedItems(prev => [
                        ...prev.filter(i => !remover.some(r => r.id === i.id)), // Remove os que foram removidos
                        ...adicionar // Adiciona os novos selecionados
                    ]);
    
                    setAdicionar([]);
                    setRemover([]);
    
                } catch (error) {
                    console.error("Erro ao salvar procedimentos:", error);
                }
            }
        });
    };
    
    
    

    const handleAddAll = () => {
        setAdicionar(professionals.filter(item => !selectedItems.some(i => i.id === item.id)));
        setRemover([]);
    };

    const handleRemoveAll = () => {
        setRemover([...selectedItems]);
        setAdicionar([]);
    };

    const filteredItems = professionals.filter(item =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const handleCostPriceChange = (id, value) => {
        setProfessionalsDataAux(prev =>
            prev.map(item =>
                item.id === id
                    ? { ...item, cost_price: parseFloat(value) || 0 }
                    : item
            )
        );
    };
    
    const handleSellingPriceChange = (id, value) => {
        setProfessionalsDataAux(prev =>
            prev.map(item =>
                item.id === id
                    ? { ...item, selling_price: parseFloat(value) || 0 }
                    : item
            )
        );
    };
    
    

    if (!isOpen) return null;

    return (
        <div className="modal-overlay-prof">
            <div className="my-modal-content-prof">
                <div>
                <div className="modal-header-prof">
                    <div className="modal-header-title">
                        <h2>Procedimentos</h2>
                        <input
                            type='text'
                            placeholder='Digite para buscar...'
                            className='form-control input-pesquisa'
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <div className="close-button-prof" onClick={handleClose}>x</div>
                </div>
                <div className='modal-msg-prof'>
                    <p>Os profissionais só serão adicionados ou removidos após apertar o botão confirmar</p>
                </div>
                </div>

                <div className='search-component'>
                    {loadingProfessionals ? (
                        <p>Carregando...</p>
                    ) : (
                        <ul className='search-results'>
                           {filteredItems.map((item, index) => {
                                const isSelected = selectedItems.some(i => i.id === item.id);
                                const isTempAdded = adicionar.some(i => i.id === item.id);
                                const isTempRemoved = remover.some(i => i.id === item.id);
                                
                                // Se o profissional já estava presente (falg_exist), ele deve ser tratado como selecionado
                                const isAdded = isSelected || isTempAdded || item.falg_exist;
                                let itemClassNew = "custom-checkbox";
                                let itemClass = "";
                                let itemClassBox = "";
                                if (isTempRemoved) {
                                    itemClass = "temp-removed"; // Item mar1cado para remoção, mas ainda não confirmado
                                    itemClassNew = "teste";
                                    itemClassBox = "teste";
                                } else if (isSelected || item.falg_exist) {
                                    itemClass = "new"; // Item já confirmado
                                } else if (isTempAdded) {
                                    itemClass = "added"; // Item que será adicionado
                                } else if (isTempRemoved) {
                                    itemClass = "removed"; // Item marcado para remoção, mas ainda não confirmado
                                }
                            
                                return (
                                    <li key={index} className={`search-item ${itemClass}`}>
                                        <div className='search-item-component'>
                                            <label className='checkbox-container'>
                                                <input
                                                    type="checkbox"
                                                    checked={isAdded}
                                                    onChange={() => handleToggleItem(item)}
                                                />
                                                <span className={`${itemClassNew}`}></span>
                                            </label>
                                            <div>
                                                {isTempAdded && (
                                                <div>
                                                    <div>
                                                        <input type="number" value={item.cost_price} onChange={(e) => handleCostPriceChange(item.id, e.target.value)} />
                                                    </div>
                                                    <div>
                                                        <input type="number" value={item.selling_price} onChange={(e) => handleSellingPriceChange(item.id, e.target.value)} />
                                                    </div>
                                                </div>
                                                )}
                                            </div>
                                            <h3>{item.name}</h3>
                                            {isAdded && !isTempRemoved ? (
                                                <div className='btn-remove-prof' onClick={() => handleToggleItem(item)}>
                                                    <img width={28} src={excluir} alt="Remover" />
                                                </div>
                                            ) : null}
                                        </div>
                                    </li>
                                );
                            })}

                        </ul>
                    )}
                    
                </div>
                <div className="btn-footer-container">
                <div className='btn-confirm' onClick={handleConfirmSelection}>
                        Confirmar
                </div>
                </div>
            </div>
        </div>
    );
};

export default ProceduresModal;
